/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * Register a new handler for the viewer.
 * This needs to be called before the viewer is initialized to ensure the handler is available.
 * So this should be called from an initialization script (`OCP\Util::addInitScript`).
 *
 * @param handler - The handler to register
 * @throws Error if the handler is invalid
 */
export function registerHandler(handler) {
    validateHandler(handler);
    window._oca_viewer_handlers ?? (window._oca_viewer_handlers = new Map());
    if (window._oca_viewer_handlers.has(handler.id)) {
        console.warn(`Handler with id ${handler.id} is already registered.`);
        return;
    }
    window._oca_viewer_handlers.set(handler.id, handler);
}
/**
 * Validate the handler object.
 *
 * @param handler - The handler to validate
 */
function validateHandler(handler) {
    const { id, mimes, mimesAliases, component } = handler;
    // checking valid handler id
    if (!id || id.trim() === '' || typeof id !== 'string') {
        throw new Error('The handler does not have a valid id');
    }
    // Nothing available to process! Failure
    if ((!mimes || !Array.isArray(mimes)) && !mimesAliases) {
        throw new Error('Handler needs a valid mime array or mimesAliases');
    }
    // checking valid handler component data
    if ((!component || (typeof component !== 'object' && typeof component !== 'function'))) {
        throw new Error('The handler does not have a valid component');
    }
}
